// KM (klubbmesterskap) presentation helpers — small pure label/format functions
// extracted verbatim from the original monolith (legacy/App.jsx). They are shared
// across several KM views (bracket, calendar, swap, trekning, class tag), so they
// live in one place in the km components folder rather than being duplicated.

// Group number from a group name: a single letter (A/B/C…) maps to 1/2/3…,
// otherwise the name is returned unchanged. Used in calendar, bracket, banepad, etc.
export function kmGroupNumber(name?: string | number | null): string | number {
  if (name == null) return '';
  const s = String(name);
  return /^[A-Za-z]$/.test(s) ? s.toUpperCase().charCodeAt(0) - 64 : s;
}

// Readable round name for the playoffs (used in calendar, banepad, etc.).
export function kmRoundFull(round?: string | null): string {
  return (
    {
      f: 'Finale',
      sf: 'Semifinale',
      qf: 'Kvartfinale',
      r16: '8-delsfinale',
      r32: '16-delsfinale',
      bronze: 'Bronsefinale',
      b_f: 'B-finale',
      b_sf: 'B-semifinale',
      b_qf: 'B-kvartfinale',
      b_r16: 'B 8-del',
      b_r32: 'B 16-del',
      b_bronze: 'B-bronse',
    }[round as string] || (round ? String(round).toUpperCase() : '')
  );
}

// Gender accent color: men = blue, women = pink, mix = purple. Used in KM tags.
export function kmAccentForGender(gender?: string | null): string {
  return gender === 'M' ? '#1961d3' : gender === 'F' ? '#c21266' : '#7845df';
}
